const ShieldIcon = ({ className }: { className?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9 11.9994L11 13.9994L15 9.99936M20.618 5.98336C17.4561 6.15127 14.3567 5.05797 12 2.94336C9.64327 5.05797 6.5439 6.15127 3.382 5.98336C3.12754 6.96847 2.99918 7.98191 3 8.99936C3 14.5904 6.824 19.2894 12 20.6214C17.176 19.2894 21 14.5914 21 8.99936C21 7.95736 20.867 6.94736 20.618 5.98336Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShieldIcon;
